import React from 'react';

const SubStepIndicator = ({ steps = [], activeStep, setStep }) => {
  const activeClass = (step) => (step === activeStep ? 'substep-indicator__step--active' : '');

  return (
    <div className="substep-indicator">
      {steps.map(({ name, label }, index) => (
        <React.Fragment key={`substep-${name}`}>
          <button
            type="button"
            className={`substep-indicator__step ${activeClass(name)}`}
            onClick={() => setStep(index)}
          >
            {label}
          </button>
          {index < steps.length - 1 ? <div className="substep-indicator__spacer" /> : null}
        </React.Fragment>
      ))}
    </div>
  );
};

export default SubStepIndicator;
